import { useSelector } from 'react-redux';
export const useSelectScreenSettings = () => useSelector(state => state.screenSettings);
// legacy exports (incorrect hook shape)
export const selectDrawer = useSelectScreenSettings;
